import {
  NotificationsContainerPropsI,
  NotificationI,
} from "@/interfaces/Notifications";
import { CommentReply } from "./components/commentReply/CommentReply";
import "./NotificationsContainer.scss";
import { useContext, useEffect, useRef } from "react";
import { seenAllNotifications } from "@/services/UserService";
import { useUserContext } from "@/context/UserContext";
import { SocketContext } from "@/context/SocketContext";
import UserStatus from "./components/userStatus/UserStatus";
import General from "./components/general/General";
import { useThemeContext } from "@/context/ThemeContext";

export default function NotificationsContainer(
  props: NotificationsContainerPropsI
) {
  const {
    notifications,
    show,
    notificationsRef,
    setNotifications,
    setPendingNotifications,
  } = props;
  const { userToken } = useUserContext();
  const socket = useContext(SocketContext);
  const { theme } = useThemeContext();

  const readAllNotifications = async () => {
    seenAllNotifications(userToken).then((res) => {
      if (res && res.status === 200) {
        setNotifications(res.data.notifications);
        setPendingNotifications(false);
      }
    });
  };

  useEffect(() => {
    if (show) {
      readAllNotifications();
    }
  }, [show]);

  useEffect(() => {
    if (socket == null) return;

    socket.on("receive-notification", (notification: NotificationI) => {
      console.log("new notification ");
      setNotifications((prev) => [notification, ...prev]);
      setPendingNotifications(true);
    });

    return () => socket.off("receive-notification");
  }, [socket]);

  function NotificationCard(notification: NotificationI) {
    switch (notification.type) {
      case "commentReply":
      case "discussionReply":
        return (
          <CommentReply notification={notification} key={notification._id} />
        );
      case "userStatus":
        return (
          <UserStatus notification={notification} key={notification._id} />
        );
      case "galleriesPhotosUser":
      case "newContentFromSubs":
        return <General notification={notification} key={notification._id} />;
      // add more cases as needed...
      default:
        return <></>;
    }
  }

  return (
    <div
      className={
        "relative w-[400px] flex-col max-w-[400px] " +
        (show ? "flex" : "hidden")
      }
      ref={notificationsRef}
    >
      <div className="fixed lgxl:right-[145px] max-lgxl:rotate-180 max-md:left-1/2 max-md:-translate-x-1/2 max-lgxl:-bottom-[40px] max-lgxl:left-[120px] -translate-y-full w-0 border-l-[20px] border-r-[20px] border-b-[20px] border-l-transparent border-r-transparent border-b-[#141416]" />
      <div
        className={
          "border-black border max-lgxl:order-2 " +
          (theme === "light"
            ? " bg-white text-black "
            : "bg-[#141416] text-white")
        }
      >
        <h3
          className={" text-2xl font-bold tracking-wide text-center m-0 p-[2%]"}
          style={{ fontFamily: "var(--orbitron-font)" }}
        >
          Notifications
        </h3>
      </div>

      <div
        className={
          "overflow-y-auto border-black border max-h-[75vh] max-lgxl:order-1" +
          (theme === "light" ? " bg-white " : " bg-[#141416]")
        }
      >
        {notifications.length > 0 ? (
          <div className="p-4 space-y-4">
            {notifications.map((notification: NotificationI, index) => {
              return NotificationCard(notification);
            })}
          </div>
        ) : (
          <div className="text-center p-8">
            <h3 className="text-gray-400 text-lg">
              You do not have notifications
            </h3>
          </div>
        )}
      </div>

      {/* Custom Scrollbar Styles */}
      <style jsx>{`
        .custom-scrollbar::-webkit-scrollbar {
          width: 6px;
        }
        .custom-scrollbar::-webkit-scrollbar-track {
          background: rgba(0, 0, 0, 0.3);
        }
        .custom-scrollbar::-webkit-scrollbar-thumb {
          background: rgba(147, 51, 234, 0.5);
          border-radius: 3px;
        }
        .custom-scrollbar::-webkit-scrollbar-thumb:hover {
          background: rgba(147, 51, 234, 0.7);
        }
      `}</style>
    </div>
  );
}
